import axios, { AxiosError, type InternalAxiosRequestConfig } from 'axios';
import { useAuthStore } from '@/stores/auth.store';

export const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
  timeout: 30_000,
  headers: { 'Content-Type': 'application/json' },
});

apiClient.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const { token, tenantSlug } = useAuthStore.getState();
  if (token) {
    config.headers.set('Authorization', `Bearer ${token}`);
  }
  if (tenantSlug) {
    config.headers.set('X-Tenant-Slug', tenantSlug);
  }
  const envSlug = import.meta.env.VITE_TENANT_SLUG as string | undefined;
  if (envSlug && !tenantSlug) {
    config.headers.set('X-Tenant-Slug', envSlug);
  }
  return config;
});

// Auto-logout on 401 (post-refresh). A refresh-token flow can be wired in later
// at this same interceptor; kept simple now to avoid token-loop bugs.
apiClient.interceptors.response.use(
  (r) => r,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      const { logout, isAuthenticated } = useAuthStore.getState();
      if (isAuthenticated) {
        logout();
        if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/login')) {
          window.location.assign('/login');
        }
      }
    }
    return Promise.reject(error);
  },
);
